<dx-load-panel [(visible)]="visible"
               [width]="'80%'"
               [height]="'50%'">
  <dxo-position of="#entity-detail">
  </dxo-position>
  <div *dxTemplate="let data of 'content'">
    <pdi-loader size="medium"></pdi-loader>
</div>
</dx-load-panel>